import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default queries are considered fresh for 5 minutes — most of our data
      // (workspace info, plans, platform statuses) only changes via mutations
      // which already invalidate the relevant keys explicitly. Aggressive
      // re-fetch on every component mount was producing ~30 redundant
      // requests per navigation in the network tab.
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
